<div class="card">
  <app-header
    [titulo]="'Conexões do Provedor: ' + (provedor?.nome || '')"
    descricao="Gerencie as diferentes conexões (ambientes) para este provedor de dados">
    <ng-template #headerActions>
      <p-button
        label="Voltar"
        icon="pi pi-arrow-left"
        severity="secondary"
        (onClick)="voltar()">
      </p-button>
    </ng-template>
  </app-header>

  <p-toolbar styleClass="mb-4">
    <ng-template pTemplate="left">
      <p-button label="Nova Conexão" icon="pi pi-plus" severity="success" (onClick)="novaConexao()"></p-button>
    </ng-template>
  </p-toolbar>

  <p-table [value]="conexoes" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
        <th pSortableColumn="ambiente">Ambiente <p-sortIcon field="ambiente"></p-sortIcon></th>
        <th pSortableColumn="urlBase">URL Base / Host</th>
        <th pSortableColumn="padrao">Padrão <p-sortIcon field="padrao"></p-sortIcon></th>
        <th pSortableColumn="ativo">Status <p-sortIcon field="ativo"></p-sortIcon></th>
        <th style="width: 10rem">Ações</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-conexao>
      <tr>
        <td><strong>{{ conexao.nome }}</strong></td>
        <td>{{ conexao.ambiente }}</td>
        <td>{{ conexao.urlBase || conexao.config?.host }}</td>
        <td>
          <p-tag [value]="conexao.padrao ? 'Sim' : 'Não'" [severity]="conexao.padrao ? 'info' : 'secondary'"></p-tag>
        </td>
        <td>
          <p-tag [value]="conexao.ativo ? 'Ativo' : 'Inativo'" [severity]="conexao.ativo ? 'success' : 'danger'"></p-tag>
        </td>
        <td>
          <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-text" (click)="editarConexao(conexao)"></button>
          <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="deletarConexao(conexao)"></button>
          <button pButton pRipple icon="pi pi-plug" class="p-button-rounded p-button-info p-button-text" pTooltip="Testar Conexão"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center p-4">Nenhuma conexão cadastrada para este provedor.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Dialog de Adicionar/Editar Conexão -->
<p-dialog [(visible)]="conexaoDialog" [style]="{width: '750px'}" [header]="isEditDialog ? 'Editar Conexão' : 'Nova Conexão'" [modal]="true" class="p-fluid">
  <ng-template pTemplate="content">
    <!-- O formulário de conexão seria similar ao do provedor-form, mas focado apenas na conexão -->
    <div class="field">
      <label for="nome">Nome</label>
      <input type="text" pInputText id="nome" [(ngModel)]="conexao.nome" required autofocus />
      <small class="p-error" *ngIf="submitted && !conexao.nome">Nome é obrigatório.</small>
    </div>
    <!-- Adicionar outros campos do formulário aqui -->
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="fecharDialog()"></button>
    <button pButton pRipple label="Salvar" icon="pi pi-check" class="p-button-text" (click)="salvarConexao()"></button>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
